import { Cell } from '@table-library/react-table-library/table';
import { showPlatform } from '../../../PromptManager/keys';
import { AI_TOOLS } from '../../../configs';

export const COLUMNS = (t) => [
    {
        label: t('ai_tracking.keyword_detail.fanoutQueries.columns.query'),
        key: 'query',
        data: 'query',
        Component: Cell,
        colSpan: 2,
        cellSize: 'minmax(250px, 2.5fr)',
    },
    {
        label: t('ai_tracking.keyword_detail.fanoutQueries.columns.prompt'),
        key: 'prompt',
        data: 'prompt',
        Component: Cell,
        cellSize: 'minmax(250px, 2.5fr)',
        sortType: 'string',
    },
    {
        label: t('ai_tracking.keyword_detail.fanoutQueries.columns.count'),
        key: 'cnt',
        data: 'cnt',
        Component: Cell,
    },
    {
        label: t('ai_tracking.keyword_detail.fanoutQueries.columns.platforms'),
        key: 'platforms',
        data: 'platforms',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            const platforms = data?.split(',') || [];
            return (
                <div className="d-flex flex-wrap gap-4">
                    {Object.keys(AI_TOOLS).map((state) => (
                        <div
                            key={state}
                            title={AI_TOOLS[state]}
                            className={`ai-tracking-platform-2 no-clickable  ${
                                platforms?.includes(state) ? '' : 'disabled'
                            }`}
                        >
                            {showPlatform(state)}
                        </div>
                    ))}
                </div>
            );
        },
    },
];
